import React, { useState } from 'react';
import { GreenCheckBox } from '../../../components/greenCheckboxes/greenCheckBox';
import { RadioButtons } from 'components/inputBox/inputBox';
import './holidaySelection.scss';

interface IHolidaySelectionProps {
  primaryLabel: string;
  secondaryLabel?: string;
  ternaryLabel?: string;
  ternaryUnits?: string;
}

const HolidaySelection = ({ primaryLabel, secondaryLabel, ternaryLabel, ternaryUnits }: IHolidaySelectionProps) => {
  const name = String(Math.floor(Math.random() * 1000));
  const [active, setActive] = useState<boolean>(false);
  const [customValue, setCustomValue] = useState<string>('');
  return (
    <div className="holidaySelection">
      <div className="title">쥬휴수당 선택</div>
      <div className="optionContainer">
        <div className="baseOptions">
          <GreenCheckBox
            onCheck={(value: boolean) => {
              setActive(value);
            }}
            rounded={true}
            defaultValue={false}
            text={primaryLabel}
          />
        </div>
        <div className="secondaryOptions" style={{ opacity: active && secondaryLabel?.length ? '100' : '0' }}>
          <input type="radio" value="Male" name={name} />
          <div className="optionLabel">{secondaryLabel}</div>
        </div>
        <div className="ternaryOptions" style={{ opacity: active && ternaryLabel?.length ? '100' : '0' }}>
          <input type="radio" value="Female" name={name} />
          <div className="optionLabel">{ternaryLabel}</div>
          <div className="customInputWrapper">
            <input
              className="customInput"
              value={customValue}
              onChange={(e) => {
                setCustomValue(e.target.value);
              }}
            />
            <div className="unit">{ternaryUnits}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidaySelection;
